import { Component, Input, ViewChild, OnInit, Output, EventEmitter, forwardRef, ChangeDetectorRef } from '@angular/core';
import { MoneyControl } from '@shared/ui/controls/money-control.model';
import { BaseControl } from '@shared/ui/controls/base-control.model';
import { NumericControl } from '@shared/ui/controls/numeric-control.model';
import { BaseComponent } from '@core/models/base-component.model';
import { CurrencySelect } from '@shared/ui/select-controls/currency-select.model';
import { CurrencyConverterService } from '@shared/services/currency-converter.service';
import { takeUntil } from 'rxjs';
import { GridLayoutModule } from '@progress/kendo-angular-layout';
import { SelectFieldComponent } from '../select-field/select-field.component';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-money-field',
    imports: [GridLayoutModule, forwardRef(() => SelectFieldComponent), NumericTextBoxModule, FormsModule],
    providers: [CurrencyConverterService],
    templateUrl: './money-field.component.html',
    styleUrls: ['./money-field.component.css']
})
export class MoneyFieldComponent extends BaseComponent implements OnInit {

  @Input() control: BaseControl;

  moneyControl: MoneyControl;
  currencySelect: CurrencySelect;

  constructor(private currencyConverter: CurrencyConverterService) { super(); }

  ngOnInit(): void {
    this.moneyControl = this.control as MoneyControl;
    this.currencySelect = this.moneyControl.currencySelect;
  }

  toNumeric(control: BaseControl): NumericControl {
    return control as NumericControl;
  }

  currencyOnChange(obj: any) {
    var value = obj['value'];
    if (value) {
      this.currencySelect.previousValue = obj['previousValue'];
      this.currencyConverter.convert(this.currencySelect, (this.moneyControl.value ?? 0)).pipe(takeUntil(this.subscription)).subscribe((data: any) => {
        console.log(data);
        this.moneyControl.value = data;
      });
    }
  }

}
